<template>
  <div class="payment-conditions">
    <div v-if="selectedPrestations.length > 0">
      <div v-for="(item, index) in selectedPrestations" :key="index + '-' + item?.prestation?.prestIdFusion">
        <div
          class="h-100 col-12 col-lg-2 py-4 d-flex flex-column position-relative flex-item w-100">
          <PaymentCondition :isSummaryDisplay="true" :prestId="item.prestation.prestIdFusion" :paymentCondition="item.prestation.paymentCondition" :displayTitle="true" :cancellation-date="item.prestation.cancelationUntil"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useStore } from "vuex";
import { computed } from "vue";

// Components
import PaymentCondition from "@/vue/planning/components/result/prestation/PaymentCondition.vue"

// Access the Vuex store
const store = useStore();

// Computed getter from the Vuex store
const selectedPrestations = computed(() => store.getters.selectedPrestations);
</script>

<style scoped>
h3 {
  margin-bottom: 0.5rem;
  color: #333;
}
</style>
